// OWNER: AREA-TEMPLATES
// Section layout: supplies the "Assets" breadcrumb for every page under /assets.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/assets')({
  staticData: { crumb: 'Assets' },
  component: Outlet,
})
